"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var pick = function pick() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
  return function () {
    for (var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, c = {}, d = 0; d < a.length;) {
      a[d] in b && (c[a[d]] = b[a[d]]), d += 1;
    }

    return c;
  };
},
    _default = pick;

exports["default"] = _default;